import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Client } from '../../../domain/models';
import { ClientService } from '../../../domain/services/client.service';

@Component({
    selector: 'app-age',
    templateUrl: './age.component.html',
    styleUrls: ['./age.component.scss'],
    standalone: false
})
export class AgeComponent implements OnInit {
    @Output() age = new EventEmitter<number>();
    @Output() back = new EventEmitter<void>();
    showError = false;
    showMessageHtml = false;
    messageHtml = '';
    client: Client | undefined;

    constructor(private readonly _client: ClientService) {}

    currentSelection = -1;

    ngOnInit() {
        this._client.latest.subscribe((client) => {
            this.client = client;
        });
    }

    ageRangeChosen(selection: number): void {
        this.currentSelection = selection;
        if (selection === 1 && this.client?.signUpHowOldMessage1Html) {
            this.messageHtml = this.client?.signUpHowOldMessage1Html;
            this.showMessageHtml = true;
        } else if (selection === 2 && this.client?.signUpHowOldMessage2Html) {
            this.messageHtml = this.client?.signUpHowOldMessage2Html;
            this.showMessageHtml = true;
        } else if (selection === 3 && this.client?.signUpHowOldMessage3Html) {
            this.messageHtml = this.client?.signUpHowOldMessage3Html;
            this.showMessageHtml = true;
        } else this.age.next(selection);
    }

    continue(): void {
        this.age.next(this.currentSelection);
    }

    goBack(): void {
        this.back.next();
    }

    goBackPrevious(): void {
        this.showMessageHtml = false;
    }
}
